import { HEIGHT, WIDTH, type World } from "./physics";
type Position = Pick<World, "x" | "y" | "camera">;
/** Keep authoritative physics separate from short-lived visual corrections. */
export class MovementCorrection {
  private offset: Position = { x: 0, y: 0, camera: 0 };
  reconcile(previous: World, next: World, snap = false) {
    if (
      snap ||
      previous.falls !== next.falls ||
      previous.respawn > 0 !== next.respawn > 0 ||
      next.time < previous.time - 0.5 ||
      Math.abs(previous.x - next.x) > WIDTH / 2 ||
      Math.abs(previous.y - next.y) > HEIGHT / 2
    ) {
      this.offset = { x: 0, y: 0, camera: 0 };
      return;
    }
    // Preserve the displayed position at packet arrival, then ease to authority.
    for (const key of ["x", "y", "camera"] as const)
      this.offset[key] += previous[key] - next[key];
  }
  advance(dt: number) {
    const decay = Math.exp(-18 * dt);
    for (const key of ["x", "y", "camera"] as const) this.offset[key] *= decay;
  }
  position(world: Position): Position {
    return {
      x: Math.max(15, Math.min(WIDTH - 15, world.x + this.offset.x)),
      y: world.y + this.offset.y,
      camera: world.camera + this.offset.camera,
    };
  }
}
